// Reserved pseudo-space room types per PRD §5.2.1. Every building gets
// one Building Common and one Building Exterior space on creation so
// admins and field staff have a home for building-scoped and
// site-scoped assets respectively.
//
// `isSerialisable: false` means the pseudo-space is singleton per
// building — the existing partial unique index on (building_id,
// room_type_id) WHERE is_pseudo = true enforces that at the DB layer.
//
// Lifted here so the seed importer and the admin building-create
// transaction share one source of truth. Admin create/edit endpoints
// must reject these names for user-created room types.

export const PSEUDO_ROOM_TYPES = [
  { name: 'Building Common', isSerialisable: false },
  { name: 'Building Exterior', isSerialisable: false },
] as const

export type PseudoRoomType = (typeof PSEUDO_ROOM_TYPES)[number]

export const PSEUDO_ROOM_TYPE_NAMES: readonly string[] = PSEUDO_ROOM_TYPES.map(
  (t) => t.name,
)
